<template>
  <layout-login>
    <div class="dingding-tip-box">
      <h2>仅支持通过钉钉工作台访问</h2>
      <div class="dingding-tip-img">
        <img
          src="../../assets/images/dingdingtip.jpg"
          width="200"
          height="200"
        >
      </div>
    </div>
  </layout-login>
</template>
<script>
import LayoutLogin from '@/components/mobile/account/LayoutLogin'
export default {
  components: {
    LayoutLogin
  },
  data () {
    return {
    }
  },
  async mounted () {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.dingding-tip-box {
  h2 {
    font-size: 16px;
    font-weight: bold;
    margin:0 0 50px;
    padding-top: 10px;
  }
  .dingding-tip-img {
    text-align: center;
  }
}
</style>
